import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaSearch } from "react-icons/fa";
import SESI from "../../assets/img/sesi.png";
import {
  Container,
  Footer,
  Header,
  Input,
  InputGroup,
  SearchButton,
  Select,
  Table,
  Td,
  Th,
  Title,
  WrapContent,
} from "../../styles/History";
import {
  getClubs,
  getContractById,
  getContractByDate,
} from "../../data/services/crew_service";
import ContractByDateModel from "../../data/models/contractByDate";
import { BackButton } from "../../styles/AddAdherense";
import { useNavigate } from "react-router-dom";
import { CREW_PAGE } from "../../core/app-urls";

export default function HistoricoAdesoes() {
  const [clubs, setClubs] = useState<any[]>([]);
  const [contracts, setContracts] = useState<any[]>([]);
  const [selectedClubId, setSelectedClubId] = useState<string>("");
  const [selectedContractId, setSelectedContractId] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [contractData, setContractData] = useState<ContractByDateModel[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchClubs() {
      const { clubs } = await getClubs();
      setClubs(clubs);
    }
    fetchClubs();
  }, []);

  const handleClubChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const clubId = event.target.value;
    setSelectedClubId(clubId);

    if (clubId) {
      const { contractById } = await getContractById(clubId);
      setContracts(contractById);
    } else {
      setContracts([]);
    }
  };

  const handleSearch = async () => {
    if (!selectedContractId || !startDate || !endDate) {
      alert("Por favor, selecione um contrato e informe as datas.");
      return;
    }

    const { contractByDate } = await getContractByDate(
      selectedContractId,
      startDate,
      endDate
    );
    setContractData(contractByDate);
  };

  return (
    <Container>
      <BackButton onClick={() => navigate(CREW_PAGE)}>
        <FaArrowLeft />
        Voltar
      </BackButton>
      <WrapContent>
        <Header>
          <Title>Histórico de adesões</Title>
          <img src={SESI} alt="SESI Logo" width={80} />
        </Header>
        <InputGroup>
          <Select onChange={handleClubChange} value={selectedClubId}>
            <option value="">Selecione o clube</option>
            {clubs.map((club: any) => (
              <option key={club.id_clube} value={club.id_clube}>
                {club.razao_social}
              </option>
            ))}
          </Select>

          <Select
            onChange={(e) => setSelectedContractId(e.target.value)}
            value={selectedContractId}
          >
            <option value="">Selecione o contrato</option>
            {contracts.map((contract: any) => (
              <option key={contract.id_contrato} value={contract.id_contrato}>
                {contract.id_contrato}
              </option>
            ))}
          </Select>

          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <SearchButton onClick={handleSearch}>
            <FaSearch color="white" />
          </SearchButton>
        </InputGroup>

        <Table>
          <thead>
            <tr>
              <Th>Nome</Th>
              <Th>CPF</Th>
              <Th>CONTRATO</Th>
              <Th>Empresa</Th>
              <Th>Data de cadastro</Th>
            </tr>
          </thead>
          <tbody>
            {contractData.length > 0 ? (
              contractData.map((contract, index) => (
                <tr key={index}>
                  <Td>{contract.associado.nome}</Td>
                  <Td>{contract.associado.cpf}</Td>
                  <Td>{contract.num_contrato}</Td>
                  <Td>{contract.empresa.nome}</Td>
                  <Td>
                    {new Date(contract.dataContrato).toLocaleDateString()}
                  </Td>
                </tr>
              ))
            ) : (
              <tr>
                <Td colSpan={4} style={{ textAlign: "center" }}>
                  Nenhum contrato encontrado.
                </Td>
              </tr>
            )}
          </tbody>
        </Table>
        {/* <Footer>Developed by WBC SISTEMAS</Footer> */}
      </WrapContent>
    </Container>
  );
}
